module.exports = __webpack_public_path__ + "static/media/arrow-down-purple.693bad0e.svg";